import type { PriceListRatioRowData, RatioTypeEnum } from 'gql/graphql';

import type { TextFieldPropValue } from '@consta/uikit/TextField';
import { TextField } from '@consta/uikit/TextField';

import '../style/AddCoefficient.css';

import type { TypeCheckedIds } from '../AddCoefficient';

interface IRenderCoefficientTextField {
    checkedIds: TypeCheckedIds;
    activeTabId: RatioTypeEnum;
    data: PriceListRatioRowData;
    handleChangesValueNote: (rowId: number) => ({ value }: { value: TextFieldPropValue }) => void;
    valueNote: Record<string, string>;
}

export const CellRenderTextField = (props: IRenderCoefficientTextField) => {
    const { data, handleChangesValueNote, checkedIds, activeTabId, valueNote } = props;

    if (!data?.code) {
        return null;
    }

    return (
        <div>
            <TextField
                value={valueNote[data.id]}
                onChange={handleChangesValueNote(data.id)}
                disabled={!checkedIds[activeTabId][data.id]}
                placeholder="Введите примечание"
                size="s"
            />
        </div>
    );
};

CellRenderTextField.displayName = 'CellRenderTextField';
